import { render } from "./wrong-configuration.vue?vue&type=template&id=fbdd3464&scoped=true&ts=true"
import script from "./wrong-configuration.vue?vue&type=script&lang=ts"
export * from "./wrong-configuration.vue?vue&type=script&lang=ts"

import "./wrong-configuration.vue?vue&type=style&index=0&id=fbdd3464&lang=scss&scoped=true"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbdd3464"]])

export default __exports__